import { render, staticRenderFns } from "./AssetTransferListBox.vue?vue&type=template&id=13566595"
import script from "./AssetTransferListBox.vue?vue&type=script&lang=js"
export * from "./AssetTransferListBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports